import { signInWithPopup } from './popup'
import { CredentialProvider } from './types'

export const appleProvider: CredentialProvider<void> = {
  id: 'apple',

  authenticate() {
    return signInWithPopup('apple', firebase => {
      const provider = new firebase.auth.OAuthProvider('apple.com')

      provider.addScope('email')
      provider.addScope('name')

      return provider
    })
  }
}
